// extracted by mini-css-extract-plugin
module.exports = {"center":"Loading_center__wCiqd","load":"Loading_load__-guUl"};